import client from '@/utils/client';

export const resetPassword = async (payload: object) => {
  try {
    const response = await client.post(`/auth/verify-reset`, {
      ...payload,
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
